import { Editor, Transforms } from 'slate';
import { AnyObject } from 'types';

export interface CustomDataInput extends AnyObject {
  annotationId: any;
}

export type UpdateAnnotation = (
  customData: CustomDataInput,
  options: any,
) => void;

export default function updateAnnotation(editor): UpdateAnnotation {
  return function (customData: CustomDataInput, options?: any): AnyObject {
    const { annotationId, ...toPopulate } = customData;

    if (options.at) {
      Transforms.select(editor, options.at);
    }

    Object.entries(toPopulate).forEach(([key, value]) => {
      Editor.addMark(editor, key, value);
    });

    if (options.at) {
      Transforms.deselect(editor);
    }

    return editor.getSelectedNode();
  };
}
